// assets/custom-product.js
// MOXIE: separado de custom.js — solo se carga en templates de producto (ver system-bottom.liquid).
// Contiene: order-delivery, product-description, quick-order-list, ficha técnica en PDF (screen-capture
// + hdt-download-product-pdf). Todas estas clases solo se usan en templates/product*.json, confirmado
// grepeando todos los templates del tema antes de moverlas.
import { $4, $$4, $id4, isRTL, formatMoney, debounce, getterAdd, getterGet, getterRunFn, btnTooltip, Drawer, VariantChangeBase } from "@theme/global";

// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally

class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays = this.config.off_day.replace(/ /g, '').split(",");
    this.nowDay = dayjs();
    var format_day = this.config.format_day,
      time = this.config.time.replace("24:00:00", "23:59:59"),
      arrDayWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      dateStart = this.config.estimateStartDate || 0,
      dateEnd = this.config.estimateEndDate || 0,
      excludeDays = this.config.cut_day.replace(/ /g, '').split(","),
      startDay = dayjs(),
      i = 0,
      endDay = dayjs(),
      j = 0,
      nowTime = this.nowDay.format('HHmmss'),
      timeint = time.replace(/ /g, '').replace(/:/g, ''),

      arrDay = themeHDN.extras.order.dayNames.replace(/ /g, '').split(","),
      arrMth = themeHDN.extras.order.monthNames.replace(/ /g, '').split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if (this.config.mode == '2') {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */

    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
      daystStart = startDayDInt + this.nth(startDayDInt),
      MntStart = arrMth[parseInt(startDay.format('M')) - 1],
      dayStart = arrDay[parseInt(startDay.format('d'))],

      EndDayDInt = parseInt(endDay.format('D')),
      daystEnd = EndDayDInt + this.nth(EndDayDInt),
      MntEnd = arrMth[parseInt(endDay.format('M')) - 1],
      dayEnd = arrDay[parseInt(endDay.format('d'))];

    //console.log( startDayDInt, EndDayDInt )
    if ($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44', dayStart).replace('t45', daystStart).replace('t46', MntStart);
    if ($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44', dayEnd).replace('t45', daystEnd).replace('t46', MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter(onlyUnique);
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = ""
        if (variant.variant_state.pre_order && this.config?.hideWithPreorder) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);


// AQUI INICIA
// --------------------------
// Countdown (simple)
// --------------------------
// MOXIE: movida desde custom.js — solo se usa en blocks/_product-order.liquid (PDP). Reutiliza el
// import de dayjs de arriba, ya cargado en este archivo.
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay = !this.textTemp.includes('[days]');
    let today = dayjs();

    const nowTime = today.format('HHmmss'),
      configTime = time.replace(/ /g, '').replace(/:/g, '')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval(this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days * 24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);
// AQUI FINALIZA


// product description - readmore
class ProductDescription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.init();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
  }
  init() {

    this.lm_btn = this.querySelector('[data-button]');
    this.content = this.querySelector('[data-content]');
    this.m_h = parseInt(this.dataset.heightLimit);
    if (!this.lm_btn || !this.content || !this.m_h) return;

    let content_h = this.content.scrollHeight;
    // console.dir(this.content);
    if (this.m_h > content_h) {
      this.lm_btn.style.setProperty('display', 'none');
      return;
    }

    this.content.style.setProperty('--height', `${content_h}px`);
    this.content.style.setProperty('max-height', `${this.m_h}px`);
    this.content.style.setProperty('--max-height', `${this.m_h}px`);

    this.lm_btn.addEventListener('click', () => {
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description', ProductDescription);

// quick order list

var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var _upate_qty,
  upate_qty_fn;
class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    const ON_CHANGE_DEBOUNCE_TIMER = 300;
    this.actions = {
      add: 'ADD',
      update: 'UPDATE',
    };
    this.quickOrderListId = '#' + this.id;
    this.sectionId = this.dataset.sectionId;
    this.updateThink();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    getterAdd(_upate_qty, this);
    document.addEventListener("cart:push:section.id", (event) => event.detail.sections.push(this.sectionId));
  }
  onSubmit(event) {
    event.preventDefault();
  }

  connectedCallback() {
    document.addEventListener($4('hdt-cart-drawer') ? 'cart:drawer:change' : 'variant:add', this.fetchQuickOrder.bind(this));
  }
  //disconnectedCallback() {}

  updateThink() {
    this.items_in_cart = $4('[update_items_in_cart]', this);
    this.items_price_in_cart = $4('[update_items_price_in_cart]', this);
    $4('form#QuickOrderList', this).addEventListener('submit', this.onSubmit.bind(this));
  }
  fetchQuickOrder(event) {
    const html = new DOMParser().parseFromString(event.detail.sections[this.sectionId], 'text/html');
    const sourceQty = html.querySelector(this.quickOrderListId);
    $4('form#QuickOrderList', this).removeEventListener('submit', this.onSubmit.bind(this));
    this.innerHTML = sourceQty.innerHTML;
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.updateThink();
    // fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const sourceQty = html.querySelector(this.quickOrderListId);
    //     this.innerHTML = sourceQty.innerHTML;
    //   })
    //   .catch((e) => { console.error(e); });
  }
  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity);
    const index = event.target.dataset.index;
    const quantity = inputValue - cartQuantity;

    if (cartQuantity > 0) {
      this.updateQuantity(index, inputValue, this.actions.update);
    } else {
      this.updateQuantity(index, quantity, this.actions.add);
    }
  }
  onLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy', true);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy', true));
  }
  deLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy', false);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy', false));
  }
  removeButton(id, quantity) {
    quantity !== 0 ? $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).removeAttribute('hidden') : $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).setAttribute('hidden', '');
  }
  updateInCart(id, variant_in_cart) {
    //  label
    $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute('hidden');
    let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

    //  totals
    let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

    // update
    if (variant_in_cart?.length !== 0 && variant_in_cart) {
      let variant_total_price = parseFloat(variant_in_cart.original_line_price)
      variant_qty_cart.innerText = variant_in_cart.quantity
      variant_total.innerText = formatMoney(variant_total_price, themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', variant_total_price);
    } else {
      variant_qty_cart.innerText = 0;
      variant_total.innerText = formatMoney(0, themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', 0);
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute('hidden', '');
    }
    this.removeT4CrurrencyData(variant_total);
  }
  removeT4CrurrencyData(el, dataset = el.dataset) {
    for (const [key, value] of Object.entries(dataset)) {
      if (key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
    }
  }
  updateTotalInCart() {
    let items_total = 0;
    let items_price = 0;

    // update items_total
    let items = $$4('[data-cart-quantity]', this);
    items.forEach(item => {
      return items_total += parseInt(item.getAttribute('data-cart-quantity'));
    })
    this.items_in_cart.innerText = items_total;

    // update items_price
    let prices = $$4('[data-variant-price]', this);
    prices.forEach(price => {
      return items_price += parseFloat(price.getAttribute('data-variant-price'));
    })
    this.items_price_in_cart.innerText = formatMoney(items_price, themeHDN.settings.currencyFormat);
    this.removeT4CrurrencyData(this.items_price_in_cart);
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  // update quantity product
  updateQuantity(id, quantity, action) {
    document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: !0 }));
    this.removeButton(id, quantity);
    this.onLoading(id);
    let bundleSections = [];
    document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
    let routeUrl = `${Shopify.routes.root}cart/change.js`;
    let body = JSON.stringify({
      quantity,
      id,
      sections_url: window.location.pathname,
      sections: bundleSections.join(",")
    });
    let fetchConfigType;

    if (action === this.actions.add) {
      fetchConfigType = 'javascript';
      routeUrl = `${Shopify.routes.root}cart/add.js`;
      body = JSON.stringify({
        items: [
          {
            quantity: parseInt(quantity),
            id: parseInt(id),
          },
        ],
        sections_url: window.location.pathname,
        sections: bundleSections.join(",")
      });
    }

    fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let cartContent = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${id}`);

        if (quantity === 0) {
          this.resetQuantityInput(id, quantityElement, true);
        }
        quantityElement.setAttribute('data-cart-quantity', quantity);
        getterRunFn(_upate_qty, this, upate_qty_fn).call(this, cartContent, parseInt(id), action, bundleSections)
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.updateTotalInCart();
        document.dispatchEvent(new CustomEvent("currency:update"));
        document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: !0 }));
        this.deLoading(id);
      });
  }
  resetQuantityInput(id, quantityElement, resetValue) {
    const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
    input.value = input.getAttribute('value');
    resetValue ? input.value = 0 : input.value = input.getAttribute('value');
  }
  updateError(updatedValue, id) {
    let message = '';
    if (typeof updatedValue === 'undefined') {
      message = window.cartStrings.error;
    } else {
      message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
    }
    this.updateLiveRegions(id, message);
  }

  updateLiveRegions(id, message) {
    const variantItemError = this.getElementById('Quick-order-list-item-error');
    if (variantItemError) {
      $4('.hdt-variant-item__error-text', variantItemError).innerHTML = message;
      variantItemError.removeAttribute('hidden');
    }
  }

}
_upate_qty = new WeakSet();
upate_qty_fn = async function (cartContent, id, action) {
  const variant_in_cart = cartContent.items.find((item) => item.variant_id === id);
  this.updateInCart(id, variant_in_cart);
  this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false }));
  //document.dispatchEvent(new CustomEvent("cart:refresh"));
  let cart = cartContent;
  if (action === this.actions.add) {
    cart = await createCartPromise();
    cart.sections = cartContent.sections;
  }
  document.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "line-item:change",
      cart,
      disabledDrawerChange: true
    }
  }));
};

customElements.define('hdt-quick-order-list', QuickOrderList);

// remove variant in cart
class QuickOrderListRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const quickOrderList = this.closest('hdt-quick-order-list');
      quickOrderList.updateQuantity(this.dataset.index, 0);
      this.setAttribute('hidden', '');
    });
  }
}

customElements.define('hdt-quick-order-list-remove-button', QuickOrderListRemoveButton);

// remove all variant in cart
class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor() {
    super();
    this.quickOrderList = this.closest('hdt-quick-order-list');
    const allVariants = Array.from(this.quickOrderList.querySelectorAll('[data-variant-id]'));
    const items = {};
    const list_variants = []
    let hasVariantsInCart = false;

    allVariants.forEach((variant) => {
      const cartQty = parseInt(variant.dataset.cartQty);
      if (cartQty > 0) {
        hasVariantsInCart = true;
        items[parseInt(variant.dataset.variantId)] = 0;
        list_variants.push(variant.dataset.variantId);
      }
    });

    if (!hasVariantsInCart) {
      this.setAttribute('hidden', '')
    }

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.quickOrderList.updateMultipleQty(items, list_variants);
      this.setAttribute('hidden', '')
    });
  }
}

customElements.define('hdt-quick-order-list-remove-all-button', QuickOrderListRemoveAllButton);

// Custom Element Test - Simple Version
class ScreenCaptureElement extends HTMLElement {
  constructor() {
    super();
    this.capturedImageData = null;
    this.render();
    this.bindEvents();
  }

  // Simple render without CSS
  render() {
    this.innerHTML = `
     <div>        
      <a id="capture-btn" style="
        background: none;
        border: none;
        color: inherit;
        font-size: inherit;
        font-family: inherit;
        font-weight: inherit;
        cursor: pointer;
        padding: 0;
        margin: 0;
        text-decoration: underline;
      ">${this.getAttribute('button-text') || 'Test Capture'}</a>
      <div id="status-message" style="
        margin-top: 10px;
        font-size: 14px;
        color: #666;
      "></div>
      <div id="progress-bar" style="display: none; margin-top: 10px;">Processing...</div>
    </div>
    `;
  }

  // Bind events
  bindEvents() {
    const captureBtn = this.querySelector('#capture-btn');
    captureBtn.addEventListener('click', () => this.captureScreen());
  }

  showStatus(message) {
    const statusMessage = this.querySelector('#status-message');
    statusMessage.textContent = message;
    console.log('Status:', message);
  }
  // Simple button state
  setButtonsState(disabled) {
    const captureBtn = this.querySelector('#capture-btn');
    captureBtn.disabled = disabled;
  }

  // Update button text with loading animation
  updateButtonText(text, isLoading = false) {
    const captureBtn = this.querySelector('#capture-btn');
    if (isLoading) {
      captureBtn.innerHTML = `<span class="loading-text"><span class="loading-spinner"></span>${text}</span>`;
    } else {
      captureBtn.innerHTML = text;
    }
  }
  // Test capture function
  async captureScreen() {
    try {
      this.setButtonsState(true);
      this.updateButtonText('Đang tải thư viện...', true);

      // Wait for libraries to load
      console.error = () => { };
      console.warn = () => { };
      console.log = () => { };

      // Also suppress window.onerror
      window.onerror = () => true;

      this.updateButtonText('Waiting...', true);

      // Use modern-screenshot
      console.log('Using modern-screenshot');
      const dataUrl = await window.modernScreenshot.domToJpeg(document.body, {
        quality: 0.4,
        width: window.innerWidth,
        height: document.body.scrollHeight,
        compress: true,
        ignoreElements: (element) => {
          return element.classList?.contains('cart-drawer') ||
            element.classList?.contains('wishlist') ||
            element.classList?.contains('compare') ||
            element.classList?.contains('predictive-search') ||
            element.classList?.contains('shopify-section-group-footer-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.tagName === 'SCRIPT' ||
            element.tagName === 'header' ||
            element.tagName === 'footer' ||
            element.tagName === 'noscript' ||
            element.tagName === 'NOSCRIPT';
        },
      });

      this.capturedImageData = dataUrl;

      this.updateButtonText('Generating PDF...', true);
      this.showStatus('Capture successful! Generating PDF...');
      await this.generatePDF();
    } catch (error) {
      this.updateButtonText('Error', false);
      this.showStatus('Error: ' + error.message);
    } finally {
      this.setButtonsState(false);
      // Reset button text to original
      const originalText = this.getAttribute('button-text') || 'Test Capture';
      this.updateButtonText(originalText, false);
    }
  }

  async generatePDF() {
    try {
      this.showStatus('Generating PDF...');
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: 'portrait',
        width: window.innerWidth,
        height: document.body.scrollHeight,
        unit: 'mm',
        format: [900, 1200],
      });

      const img = new Image();
      img.src = this.capturedImageData;

      await new Promise((resolve) => {
        img.onload = resolve;
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Tính tỷ lệ scale để fit ảnh
      const scaleX = pageWidth / img.width;
      const scaleY = pageHeight / img.height;
      const scale = Math.min(scaleX, scaleY); // Chọn scale nhỏ hơn

      const finalWidth = img.width * scale;
      const finalHeight = img.height * scale;

      // Center ảnh trên trang
      const x = (pageWidth - finalWidth) / 2;
      const y = (pageHeight - finalHeight) / 2;

      pdf.addImage(this.capturedImageData, 'JPEG', x, y, finalWidth, finalHeight, undefined, 'FAST');

      const filename = `screen-capture-${Date.now()}.pdf`;
      pdf.save(filename);

      this.updateButtonText('PDF generated successfully!', false);
      this.showStatus('PDF generated successfully!');

    } catch (error) {
      this.updateButtonText('Error generating PDF', false);
      this.showStatus('PDF Error: ' + error.message);
    } finally {
    }
  }

  connectedCallback() {
    setTimeout(() => {
      console.log('Library status check:', {
        modernScreenshot: !!window.modernScreenshot,
        jspdf: !!window.jspdf
      });
    }, 1000);
  }
}

customElements.define('screen-capture', ScreenCaptureElement);

// By Mr Linh =====================
class HdtDownloadProductPdf extends HTMLElement {
  static get observedAttributes() {
    return [
      'targets','exclude','filename','page','landscape',
      'margin','scale','usecors','removebackground',
      'disablesticky','bgcolor','imageformat'
    ];
  }

  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() { this.addEventListener('click', this._onClick); }
  disconnectedCallback() { this.removeEventListener('click', this._onClick); }

  async _printPDF() {
    const exportDiv = document.querySelector('.hdt-export-pdf-main');
    if (!exportDiv) throw new Error('Plantilla de exportación no encontrada');

    // Poblar los holders con datos del DOM en vivo (specs, energy label)
    exportDiv.querySelectorAll('[data-clone_selector]').forEach(holder => {
      const sel = holder.getAttribute('data-clone_selector');
      if (!sel) return;
      holder.innerHTML = '';
      document.querySelectorAll(sel).forEach(el => holder.appendChild(el.cloneNode(true)));
    });

    // Mover al root del body para que el print CSS funcione correctamente
    const originalParent = exportDiv.parentElement;
    const originalNext = exportDiv.nextSibling;
    exportDiv.classList.remove('hdt-hidden');
    exportDiv.style.display = 'block';
    document.body.appendChild(exportDiv);

    // Esperar imágenes (máximo 3s)
    const imgs = Array.from(exportDiv.querySelectorAll('img'));
    if (imgs.length) {
      await Promise.race([
        Promise.all(imgs.map(img => new Promise(res => {
          if (img.complete && img.naturalWidth > 0) return res();
          img.addEventListener('load', res, { once: true });
          img.addEventListener('error', res, { once: true });
        }))),
        new Promise(r => setTimeout(r, 3000))
      ]);
    }

    // CSS de impresión: ocultar todo el resto de la página
    const style = document.createElement('style');
    style.id = 'hdt-print-pdf-style';
    style.textContent = '@media print { @page { size: A4 portrait; margin: 0; } body > *:not(.hdt-export-pdf-main) { display: none !important; } .hdt-export-pdf-main { display: block !important; width: 210mm; min-height: 0 !important; background: #fff; } }';
    document.head.appendChild(style);

    window.print();

    // Restaurar después del diálogo de impresión
    setTimeout(() => {
      exportDiv.classList.add('hdt-hidden');
      exportDiv.style.display = '';
      if (originalNext) { originalParent.insertBefore(exportDiv, originalNext); }
      else { originalParent.appendChild(exportDiv); }
      const s = document.getElementById('hdt-print-pdf-style');
      if (s) s.remove();
    }, 1000);
  }

  async _loadLibraries() {
    const libs = (window.themeHDN && window.themeHDN.pdfLibs) || {};
    const load = (src) => new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = () => reject(new Error('No se pudo cargar: ' + src));
      document.head.appendChild(s);
    });
    const pending = [];
    if (!window.html2canvas) {
      pending.push(load(libs.html2canvas || 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js'));
    }
    if (!(window.jspdf && window.jspdf.jsPDF)) {
      pending.push(load(libs.jsPDF || 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js'));
    }
    if (pending.length) await Promise.all(pending);
  }

  _parseSelectors(attr) {
    const raw = (this.getAttribute(attr) || '').trim();
    if (!raw) return [];
    return raw.split(',').map(s => s.trim()).filter(Boolean);
  }

  _normalizeLazyMedia(root) {
    root.querySelectorAll('picture source').forEach(src => {
      const dss = src.getAttribute('data-srcset') || src.getAttribute('data-lazy-srcset') || src.getAttribute('data-src');
      if (dss) src.setAttribute('srcset', dss);
    });
    root.querySelectorAll('img').forEach(img => {
      const lazySrc = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('data-lazy-src');
      const lazySrcset = img.getAttribute('data-srcset') || img.getAttribute('data-lazy-srcset');
      if (lazySrc) img.setAttribute('src', lazySrc);
      if (lazySrcset) img.setAttribute('srcset', lazySrcset);
      img.setAttribute('loading','eager');
      img.setAttribute('decoding','sync');
      img.setAttribute('fetchpriority','high');
      if (!img.getAttribute('crossorigin')) img.setAttribute('crossorigin','anonymous');
      img.style.setProperty('max-width','100%');
      img.style.setProperty('height','auto');
      img.style.setProperty('display','block');
      img.style.setProperty('opacity','1');
      img.style.setProperty('visibility','visible');
    });
  }

  async _waitImages(root) {
    const imgs = Array.from(root.querySelectorAll('img'));
    if (!imgs.length) return;
    imgs.forEach(img => {
      const lazySrc = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('data-lazy-src');
      const lazySrcset = img.getAttribute('data-srcset') || img.getAttribute('data-lazy-srcset');
      if (lazySrc) img.setAttribute('src', lazySrc);
      if (lazySrcset) img.setAttribute('srcset', lazySrcset);
      img.setAttribute('loading', 'eager');
      if (!img.getAttribute('crossorigin')) img.setAttribute('crossorigin', 'anonymous');
    });
    const timeout = new Promise(r => setTimeout(r, 3000));
    await Promise.race([
      Promise.all(imgs.map(img => new Promise(res => {
        if (img.complete) return res();
        const done = () => res();
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }))),
      timeout
    ]);
  }

  _pruneExclusions(root, extraSelectors) {
    const builtIn = ['hdt-download-product-pdf','.pdf-exclude','[data-pdf-exclude]'];
    const selectors = builtIn.concat(extraSelectors || []);
    if (!selectors.length) return;
    root.querySelectorAll(selectors.join(',')).forEach(n => n.remove());
  }

  _disableSticky(root, selectors) {
    const defaults = ['.hdt-group-product-block','.hdt-product-media-wrapps','.hdt-product-info__list'];
    const list = (selectors && selectors.length) ? selectors : defaults;
    root.querySelectorAll(list.join(',')).forEach(el => {
      el.style.position = 'static';
      el.style.top = 'auto';
      el.style.bottom = 'auto';
      el.style.left = 'auto';
      el.style.right = 'auto';
    });
  }

  _disableProblematicComponents() {
    // Desactivar componentes problemáticos durante la exportación PDF
    const problematicSelectors = [
      'hdt-predictive-search',
      'hdt-wishlist-a',
      'hdt-compare-a',
      'hdt-quick-search',
      'hdt-product-recommendations',
      'hdt-product-recently',
      'hdt-back-to-top',
      'hdt-cookies-bar'
    ];
    
    problematicSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.style.display = 'none';
        el.setAttribute('data-pdf-disabled', 'true');
      });
    });
  }

  _enableProblematicComponents() {
    // Reactivar componentes problemáticos después de la exportación PDF
    document.querySelectorAll('[data-pdf-disabled="true"]').forEach(el => {
      el.style.display = '';
      el.removeAttribute('data-pdf-disabled');
    });
  }

  _expandProductMedia(container) {
    const medias = container.querySelectorAll('.hdt-product-media__main');
    if (!medias.length) return;

    medias.forEach(media => {
      const viewport = media.querySelector('.hdt-slider__viewport');
      const track = media.querySelector('.hdt-slider__container');
      const slides = media.querySelectorAll('.hdt-slider__slide');

      slides.forEach((s, i) => {
        if (i === 0) {
          if (s.hasAttribute('hidden')) s.removeAttribute('hidden');
          s.style.removeProperty('transform');
          s.style.removeProperty('position');
          s.style.removeProperty('left');
          s.style.removeProperty('right');
          s.style.removeProperty('top');
          s.style.removeProperty('bottom');
          s.style.setProperty('display','block','important');
          s.style.setProperty('width','auto','important');
          s.style.setProperty('height','auto','important');
        } else {
          s.style.setProperty('display','none','important');
        }
      });
      if (viewport) {
        viewport.style.setProperty('overflow','visible','important');
        viewport.style.setProperty('height','auto','important');
      }
      if (track) {
        track.style.removeProperty('transform');
        track.style.setProperty('display','block','important');
        track.style.setProperty('width','auto','important');
      }
      media.classList.remove('is--enabled');
    });
  }

  _expandProductDescription(container) {
    // Expandir descripción detallada para PDF
    const descriptions = container.querySelectorAll('.hdt-product-description, .hdt-rte, .hdt-product-tabs__content, .hdt-group-product-block');
    
    descriptions.forEach(desc => {
      // Remover restricciones de altura
      desc.style.height = 'auto';
      desc.style.maxHeight = 'none';
      desc.style.minHeight = 'auto';
      desc.style.overflow = 'visible';
      
      // Asegurar que el contenido se muestre completamente
      const content = desc.querySelector('.hdt-product-tabs__panel, .hdt-rte, .hdt-product-description');
      if (content) {
        content.style.height = 'auto';
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        content.style.display = 'block';
      }
      
      // Expandir acordeones y tabs
      const accordions = desc.querySelectorAll('details, .hdt-accordion');
      accordions.forEach(accordion => {
        accordion.open = true;
        accordion.setAttribute('open', '');
      });
      
      // Mostrar contenido oculto pero excluir opciones de stock
      const hiddenElements = desc.querySelectorAll('[hidden], .hdt-hidden');
      hiddenElements.forEach(el => {
        // Excluir elementos relacionados con stock
        const isStockElement = el.closest('.hdt-product-stock, .hdt-stock-options, .hdt-variant-selector, .hdt-product-form__options') ||
                              el.classList.contains('hdt-stock-option') ||
                              el.querySelector('.hdt-stock-option') ||
                              el.textContent.includes('Stock bajo') ||
                              el.textContent.includes('En stock') ||
                              el.textContent.includes('Agotado') ||
                              el.textContent.includes('Preordenar');
        
        if (!isStockElement) {
          el.removeAttribute('hidden');
          el.classList.remove('hdt-hidden');
          el.style.display = 'block';
        }
      });
    });
  }

  _hideStockOptions(container) {
    // Ocultar opciones de stock que no deberían aparecer en el PDF
    const stockSelectors = [
      '.hdt-product-stock',
      '.hdt-stock-options', 
      '.hdt-variant-selector',
      '.hdt-product-form__options',
      '[data-stock-option]',
      '.hdt-stock-option'
    ];
    
    stockSelectors.forEach(selector => {
      container.querySelectorAll(selector).forEach(el => {
        // Verificar si contiene texto de opciones de stock
        const text = el.textContent.toLowerCase();
        if (text.includes('stock bajo') || 
            text.includes('en stock') || 
            text.includes('agotado') || 
            text.includes('preordenar') ||
            text.includes('restantes')) {
          el.style.display = 'none';
          el.setAttribute('data-pdf-hidden', 'true');
        }
      });
    });
  }

  _optimizeTagsForPDF(container) {
    // Optimizar etiquetas/tags para PDF
    const tagSelectors = [
      '.hdt-tag-list',
      '.hdt-product-tags',
      '.hdt-badge',
      '.hdt-tag',
      '.hdt-label'
    ];
    
    tagSelectors.forEach(selector => {
      container.querySelectorAll(selector).forEach(tagContainer => {
        // Asegurar que las etiquetas se muestren correctamente
        tagContainer.style.display = 'flex';
        tagContainer.style.flexWrap = 'wrap';
        tagContainer.style.gap = '8px';
        tagContainer.style.margin = '10px 0';
        
        // Optimizar etiquetas individuales
        const tags = tagContainer.querySelectorAll('li, .hdt-badge, .hdt-tag, .hdt-label');
        tags.forEach(tag => {
          tag.style.display = 'inline-block';
          tag.style.padding = '4px 8px';
          tag.style.margin = '2px';
          tag.style.backgroundColor = '#f0f0f0';
          tag.style.color = '#333';
          tag.style.border = '1px solid #ddd';
          tag.style.borderRadius = '4px';
          tag.style.fontSize = '12px';
          tag.style.fontWeight = '500';
          tag.style.textDecoration = 'none';
          tag.style.whiteSpace = 'nowrap';
          
          // Aplicar estilos específicos según el tipo de etiqueta
          const text = tag.textContent.toLowerCase();
          if (text.includes('reba') || text.includes('descuento') || text.includes('off') || text.includes('%')) {
            tag.style.backgroundColor = '#dc3545';
            tag.style.color = 'white';
            tag.style.borderColor = '#dc3545';
            tag.style.fontWeight = 'bold';
          } else if (text.includes('stock') || text.includes('disponible')) {
            tag.style.backgroundColor = '#28a745';
            tag.style.color = 'white';
            tag.style.borderColor = '#28a745';
          } else if (text.includes('agotado') || text.includes('out of stock')) {
            tag.style.backgroundColor = '#6c757d';
            tag.style.color = 'white';
            tag.style.borderColor = '#6c757d';
          }
        });
      });
    });
  }

  _prepareExportWrapper(uniqueNodes, bgColor) {
    const wrapper = document.createElement('div');
    wrapper.style.background = bgColor || '#ffffff';
    
    // Agregar clase especial para evitar inicialización de componentes durante PDF
    wrapper.classList.add('hdt-pdf-export-mode');
    
    // Desactivar componentes problemáticos durante la exportación PDF
    wrapper.setAttribute('data-pdf-export', 'true');

    let exportMain = document.querySelector('.hdt-export-pdf-main');
    if (exportMain) {
      exportMain = exportMain.cloneNode(true);
    } else {
      exportMain = document.createElement('div');
      exportMain.className = 'hdt-hidden hdt-export-pdf-main hdt-product-export-pdf';
      exportMain.setAttribute('aria-hidden','true');
      exportMain.innerHTML = `
        <div class="hdt-export-pdf-main-container">
          <div class="hdt-pdf-exp-part hdt-pdf-exp-part--left">
            <div class="hdt-product-media__main--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-product-media__main"></div>
          </div>
          <div class="hdt-pdf-exp-part hdt-pdf-exp-part--right">
            <div class="hdt-group-product-block--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-group-product-block"></div>
            <div class="hdt-product-tabs--clone hdt-pdf-exp-holder" data-clone_selector=".hdt-product-tabs"></div>
          </div>
        </div>
      `;
    }

    // Agregar clase especial al exportMain también
    exportMain.classList.add('hdt-pdf-export-mode');

    exportMain.style.display = 'block';
    exportMain.style.background = bgColor || '#ffffff';

    exportMain.querySelectorAll('.hdt-pdf-exp-holder').forEach(holder => {
      holder.innerHTML = '';
      const sel = holder.getAttribute('data-clone_selector');
      if (sel) {
        document.querySelectorAll(sel).forEach(el => {
          const c = el.cloneNode(true);
          c.style.background = bgColor || '#ffffff';
          // Agregar clase especial a los elementos clonados
          c.classList.add('hdt-pdf-export-mode');
          this._normalizeLazyMedia(c);
          holder.appendChild(c);
        });
      }
    });

    this._expandProductMedia(exportMain);
    this._expandProductDescription(exportMain);
    this._hideStockOptions(exportMain);
    this._optimizeTagsForPDF(exportMain);
    this._normalizeLazyMedia(exportMain)
    wrapper.appendChild(exportMain);

    uniqueNodes.forEach(node => {
      if (node.classList && node.classList.contains('hdt-export-pdf-main')) return;
      const c = node.cloneNode(true);
      c.style.background = bgColor || '#ffffff';
      // Agregar clase especial a los nodos únicos también
      c.classList.add('hdt-pdf-export-mode');
      this._expandProductDescription(c);
      this._hideStockOptions(c);
      this._optimizeTagsForPDF(c);
      this._normalizeLazyMedia(c);
      wrapper.appendChild(c);
    });

    return wrapper;
  }

  _canvasToPDF(canvas, pdf, opts) {
    const { bgColor = '#ffffff', imgType = 'JPEG' } = opts;
    const margin = Math.max(0, opts.marginMm || 12);
    const pdfW = pdf.internal.pageSize.getWidth();
    const pdfH = pdf.internal.pageSize.getHeight();
    const contentWmm = pdfW - margin*2;
    const contentHmm = pdfH - margin*2;
    const mm = (px)=>px*25.4/96;
    const px = (mmVal)=>mmVal*96/25.4;

    const cw = canvas.width, ch = canvas.height;
    const targetWpx = px(contentWmm);
    const scaleFactor = targetWpx/cw;
    const pageHpx = px(contentHmm)/scaleFactor;

    const pageCanvas = document.createElement('canvas');
    const ctx = pageCanvas.getContext('2d');

    const pages = Math.max(1, Math.ceil(ch / pageHpx));
    for (let i=0;i<pages;i++) {
      const sy = Math.floor(i * pageHpx);
      const sh = Math.min(pageHpx, ch - sy);

      pageCanvas.width = cw;
      pageCanvas.height = Math.max(1, Math.floor(sh));
      ctx.save();
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      ctx.drawImage(canvas, 0, sy, cw, sh, 0, 0, cw, sh);
      ctx.restore();

      const mime = imgType.toUpperCase() === 'PNG' ? 'image/png' : 'image/jpeg';
      const quality = mime === 'image/jpeg' ? 0.75 : undefined;
      const imgData = pageCanvas.toDataURL(mime, quality);

      if (i>0) pdf.addPage({ orientation: opts.orientation, format: opts.pageFormat });

      const sliceHmm = (sh * scaleFactor) * 25.4 / 96;
      const drawHmm = Math.min(sliceHmm, contentHmm);
      pdf.addImage(imgData, imgType.toUpperCase(), margin, margin, contentWmm, drawHmm, undefined, 'FAST');
    }
  }

  async _exportToPDF({targets,excludeSelectors,filename,page,landscape,marginMm,scale,useCORS,disableStickySelectors,bgColor,imgType,removeBg}) {
    if (!window.html2canvas || !(window.jspdf && window.jspdf.jsPDF)) throw new Error('Libraries missing');

    // Marcar que estamos en modo de exportación PDF
    window.HDT_PDF_EXPORT_MODE = true;
    
    // Desactivar componentes problemáticos durante la exportación PDF
    this._disableProblematicComponents();

    const nodes = (targets||[]).flatMap(sel => Array.from(document.querySelectorAll(sel)));
    const uniqueNodes = Array.from(new Set(nodes));
    if (!uniqueNodes.length) throw new Error('No targets found');

    const holder = document.createElement('div');
    holder.setAttribute('aria-hidden','true');
    holder.style.position='fixed';
    holder.style.left='-100000px';
    holder.style.top='0';
    holder.style.zIndex='-1';
    holder.style.background = bgColor || '#ffffff';

    const base = uniqueNodes[0];
    const baseRect = base.getBoundingClientRect();

    const wrapper = this._prepareExportWrapper(uniqueNodes, bgColor);
    wrapper.style.width = Math.min(baseRect.width||base.offsetWidth||800, 900)+'px';

    this._pruneExclusions(wrapper, excludeSelectors);
    this._disableSticky(wrapper, disableStickySelectors);

    holder.appendChild(wrapper);
    document.body.appendChild(holder);

    try {
      await this._waitImages(wrapper);
      await new Promise(r => setTimeout(r, 50));
      const h2cBg = (removeBg && (bgColor === 'transparent' || bgColor === '')) ? null : (bgColor || '#ffffff');

      const canvas=await window.html2canvas(wrapper,{
        scale: 1,
        useCORS:!!useCORS,
        allowTaint:false,
        backgroundColor: h2cBg,
        logging:false,
        imageTimeout: 5000
      });

      const {jsPDF}=window.jspdf;
      const orientation=landscape?'landscape':'portrait';
      const pdf=new jsPDF({orientation,unit:'mm',format:page||'a4'});

      this._canvasToPDF(canvas,pdf,{
        marginMm:marginMm??12,
        orientation,
        pageFormat:page||'a4',
        bgColor: (h2cBg === null ? '#ffffff' : h2cBg) || '#ffffff',
        imgType: (imgType || 'JPEG')
      });

      pdf.save(filename||'download.pdf');
    } finally {
      // Limpiar la variable global de modo PDF
      window.HDT_PDF_EXPORT_MODE = false;
      
      // Reactivar componentes problemáticos
      this._enableProblematicComponents();
      
      holder.remove();
    }
  }

  async _onClick(e) {
    const btn = (e.target && e.target.closest('button')) || this;
    const hasBtnState = ('disabled' in btn)&&('textContent' in btn);
    const prevDisabled = hasBtnState?btn.disabled:undefined;
    const prevHTML = hasBtnState?btn.innerHTML:undefined;
    try {
      if(hasBtnState){
        btn.disabled=true;
        btn.style.position = 'relative';
        btn.style.overflow = 'visible';
        btn.innerHTML = btn.innerHTML + '<div class="loading-ring" style="position: absolute; top: 50%; left: 50%; width: 56px; height: 56px; border: 2px solid rgba(36,88,141,0.1); border-top: 2px solid rgba(36,88,141,0.6); border-radius: 50%; pointer-events: none; transform: translate(-50%, -50%);"></div>';
        if(!document.querySelector('#loading-spinner-style')){
          const style = document.createElement('style');
          style.id = 'loading-spinner-style';
          style.textContent = '@keyframes spin { from { transform: translate(-50%, -50%) rotate(0deg); } to { transform: translate(-50%, -50%) rotate(360deg); } } .loading-ring { animation: spin 1s linear infinite !important; }';
          document.head.appendChild(style);
        }
      }
      await this._printPDF();
    } catch(err) {
      alert('Error al generar la ficha técnica: '+(err?.message||err));
    } finally {
      if(hasBtnState){
        btn.disabled=prevDisabled;
        btn.style.position = '';
        btn.style.overflow = '';
        const loadingRing = btn.querySelector('.loading-ring');
        if(loadingRing) loadingRing.remove();
        if(prevHTML) btn.innerHTML=prevHTML;
      }
    }
  }
}

customElements.define('hdt-download-product-pdf', HdtDownloadProductPdf);
